import React, { useRef, useState, useEffect, useCallback } from 'react';
import mixpanel from 'mixpanel-browser';

import { Edit as EditIcon, Close as CloseIcon } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';

import { Loader } from '../Elements/Loader';
import { UserProfileView } from './UserProfileView';
import { UserProfileEdit } from './UserProfileEdit';

import { EDIT } from '../../constants/Profile';
import { getUserFullName } from '../../utils';

import './UserProfile.css';

export const UserProfile = ({ user, currentPath, userAddress, token, loading, csrfToken }) => {
  // Profile state and loggic
  const [activeTab, setActiveTab] = useState('Edit Profile');
  const [viewOnly, setViewOnly] = useState(true);
  const fileInputRef = useRef(null);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const initialForm = {
    firstName: '',
    lastName: '',
    profession: '',
    dob: '2000-07-06',
    phone: '',
    email: '',
    address: '',
    molasses: '',
  };
  const [form, setForm] = useState(initialForm);

  // Validate
  const validate = () => {
    const err = {};
    if (!form.firstName.trim()) err.firstName = 'First name is required';
    if (!form.lastName.trim()) err.lastName = 'Last name is required';
    if (!form.profession.trim()) err.profession = 'Profession is required';
    if (!form.dob) err.dob = 'Date of birth is required';
    else {
      const [y, m, d] = form.dob.split('-').map(Number);
      const birth = new Date(y, m - 1, d),
        today = new Date();
      let age = today.getFullYear() - birth.getFullYear();
      if (
        today.getMonth() < birth.getMonth() ||
        (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate())
      )
        age--;
      if (age < 18) err.dob = 'You must be at least 18';
    }
    if (!form.email) err.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) err.email = 'Invalid email address';
    if (!form.phone) err.phone = 'Phone number is required';
    //regex validation phone format
    else if (!/^\+?1?\s*\-?\(?\d{3}\)?\s*\-?\d{3}\s*\-?\d{4}$/.test(form.phone))
      err.phone = 'Invalid phone number';
    if (!form.address.trim()) err.address = 'Address is required';

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // Cleanup avatarURL object
  useEffect(
    () => () => {
      if (avatarUrl) URL.revokeObjectURL(avatarUrl);
    },
    [avatarUrl],
  );

  const handleViewOnly = (val) => {
    setViewOnly(val);
  };

  if (loading) {
    return (
      <div className="user-profile-wrapper">
        <div className="profile-card">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className="user-profile-wrapper">
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-details">
            <div className="profile-image">
              {/* <img src={avatarUrl} alt="avatar" className="avatar-img" /> */}
              {/* <input
                  type="file"
                  accept="image/*"
                  ref={() => {}}
                  onChange={''}
                  style={{ display: 'none' }}
                /> */}
            </div>
            <div className="profile-name">{getUserFullName(user)}</div>
          </div>

          {viewOnly ? (
            <Button
              onClick={() => {
                handleViewOnly(false);
                mixpanel.track('Profile Page', {
                  userId: user.id,
                  action: EDIT,
                });
              }}
            >
              <div className="edit-wrapper">
                <div>
                  <EditIcon />
                </div>
                <div className="edit-text">{EDIT}</div>
              </div>
            </Button>
          ) : (
            <IconButton
              onClick={() => {
                handleViewOnly(true);
                mixpanel.track('Profile Page', {
                  userId: user.id,
                  action: 'View',
                });
              }}
              sx={{
                '&:hover': { backgroundColor: 'black', color: 'white' },
                backgroundColor: 'black',
                color: 'white',
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>

        {viewOnly ? (
          <UserProfileView user={user} userAddress={userAddress} />
        ) : (
          <UserProfileEdit
            user={user}
            csrfToken={csrfToken}
            userAddress={userAddress}
            onCancelEdit={() => {
              handleViewOnly(true);
              mixpanel.track('Profile Page', {
                userId: user.id,
                path: 'View',
                action: 'Cancel',
              });
            }}
            onSave={() => {
              handleViewOnly(true);
              mixpanel.track('Profile Page', {
                userId: user.id,
                path: 'View',
                action: 'Save',
              });
            }}
            token={token}
          />
        )}
      </div>
    </div>
  );
};
